/**
 * Synchronous org snapshot for `rtLogService.getContext` (outside React).
 * Updated by a bridge under SessionProvider.
 */

let currentOrgId: string | null = null

export function setLogContextOrgId(orgId: string | null): void {
  currentOrgId = orgId
}

export function getLogContextOrgId(): string | null {
  return currentOrgId
}
